import { GlEmptyState } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import ERROR_STATE_SVG from '@gitlab/svgs/dist/illustrations/empty-state/empty-job-failed-md.svg?url';
export default {
    name: 'PipelinesErrorState',
    components: {
        GlEmptyState
    },
    ERROR_STATE_SVG
};
